/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import {
  Button,
  Col, Row, Form, Drawer, Input, Upload, Select, Spin,
} from 'antd';
import './home.less';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { useForm } from 'antd/lib/form/Form';
import utility from '../../Global/Utility';
import kudLogo from '../../Assets/Images/KUD_Logo_White.png';
import chairs from '../../Assets/Images/chairs.png';
import shakehands from '../../Assets/Images/shakehands.png';
import crowed from '../../Assets/Images/crowed.png';
import ourwork from '../../Assets/Images/Homepage Image-02.png';
import ourservice from '../../Assets/Images/ourServiceMain.jpg';
import Routes from '../../Global/Routes';
import { Toast } from '../../Components';
import { NewsLetterType, JobVacancyType, JobApplyForm } from '../../Global/interface';
import newsLetterService from '../../Services/newsLetterService';
import jobVacancyService from '../../Services/jobVacancyService';
import uploadCvService from '../../Services/uploadCvService';
import rules from './jobApply.validation';
import Constant from '../../Global/Constant';

const { Option } = Select;
function KUDhome() {
  const history = useHistory();
  const [form] = useForm();
  const [openApply, setOpenApply] = useState(false);
  const [jobVacancyList, setJobVacancyList] = useState<JobVacancyType>();
  const [openNewsLetter, setOpenNewLetter] = useState<boolean>(false);
  const [newLetterList, setNewsLetterList] = useState<NewsLetterType>();
  const [isLoading, setIsLoading] = useState(false);
  const [jobDetails, setJobDetails] = useState<{ description: string; requirements: string }>({
    description: '',
    requirements: '',
  });

  useEffect(() => {
    getNewsLetterList();
  }, []);

  const showDrawerInApply = () => {
    setOpenApply(true);
    getJobVacancyList();
  };
  const showDrawerInNewLetter = () => {
    setOpenNewLetter(true);
  };

  const onCloseInApply = () => {
    form.resetFields();
    setOpenApply(false);
  };

  const onCloseInNewLetter = () => {
    setOpenNewLetter(false);
  };

  const navigateToOurWork = () => {
    history.push(Routes.ourWork);
  };

  const navigateToOurService = () => {
    history.push(Routes.ourService);
  };

  const getNewsLetterList = async () => {
    const response = await newsLetterService.listNewsLetter();
    setNewsLetterList(response?.data);
  };

  const getJobVacancyList = async () => {
    const response = await jobVacancyService.listJobVacancy();
    setJobVacancyList(response?.data);
  };

  const createJobApply = async (jobApply: JobApplyForm) => {
    try {
      const params: JobApplyForm = jobApply;
      setIsLoading(true);
      await uploadCvService.uploadCV(params);
      setIsLoading(false);
      setOpenApply(false);
      form.resetFields();
      Toast.success(Constant.jobFormSubmitSuccess);
    } catch (err: any) {
      setIsLoading(false);
      Toast.error(err);
    }
  };

  const onFinishForm = (values: JobApplyForm) => {
    createJobApply(values);
  };

  const openBookingKUD = () => {
    window.open(Constant.bookingKudUrl);
  };

  const handleJobChange = (value: string) => {
    const selectedJob = jobVacancyList?.jobVacancies.find(
      (job: any) => job._id === value,
    );
    setJobDetails({
      description: selectedJob?.job_description?.toString() || '',
      requirements: selectedJob?.requirements?.toString() || '',
    });
  };

  return (
    <Row>
      <Col className="our-work-sep" lg={12} md={12} sm={24} xs={24}>
        <div className="mb-5 mt-2">
          <img style={{ width: '120px', height: '50px' }} src={kudLogo} alt="logo" />
        </div>
        <p className="fs-16">KUD, a leading project management company in Kuwait since 2004, offers
          client-centered solutions across all project phases. With expertise in design,
          construction, and facility management, their ISO-certified team ensures
          top-quality services, guiding projects from inception to handover. They
          manage diverse project types, ensuring on-time, budget-friendly, safe, and
          high-quality completion through comprehensive services spanning design,
          construction, facility management, project control, safety, quality, and value
          engineering.</p>
        <div className="our-work-threecol">
          <Row gutter={[16, 16]}>
            <Col lg={8} md={8} sm={12} xs={24}>
              <div className="img-btn">
                <img src={chairs} alt="chairs" />
              </div>
              <Button shape="round" onClick={openBookingKUD}>KUDPTI</Button>
            </Col>
            <Col lg={8} md={8} sm={12} xs={24}>
              <div className="img-btn">
                <img src={shakehands} alt="shakehands" />
                <Button shape="round" style={{ width: '120px' }} className="apply-btn" onClick={showDrawerInApply}>Work with Us</Button>
                <Drawer className="apply-modal" title="Apply for a position at KUD" placement="bottom" onClose={onCloseInApply} visible={openApply}>
                  <Spin spinning={isLoading}>
                    <div className="modal-inner">
                      <Form layout="vertical" onFinish={onFinishForm} form={form} validateTrigger={['onBlur', 'onSubmit', 'onChange']} scrollToFirstError>
                        <Form.Item label="Full Name" name="full_name" normalize={utility.trimSpacesInValues} rules={rules.full_name}>
                          <Input placeholder="Enter your full name" maxLength={100} />
                        </Form.Item>
                        <Form.Item label="Email Address" name="email" normalize={utility.trimSpacesInValues} rules={rules.email}>
                          <Input placeholder="Enter you email" type="email" maxLength={50} />
                        </Form.Item>
                        <Form.Item
                          label="Upload your CV"
                          name="cv"
                          rules={rules.file_upload}
                          valuePropName="fileList"
                          getValueFromEvent={(event) => (
                            event?.fileList
                          )}
                        >
                          <Upload className="custom-upload" maxCount={1} accept=".doc,.docx,application/pdf" beforeUpload={() => false}>
                            <span className="cus-upload-input" />
                            <Button>Browse</Button>
                          </Upload>
                        </Form.Item>
                        <Form.Item label="Current Vacancies" name="job" rules={rules.job}>
                          <Select
                            className="custom-dropdown"
                            placeholder="Select a position"
                            onChange={handleJobChange}
                          >
                            {jobVacancyList?.jobVacancies?.map((job: any) => (
                              <Option value={job?._id}> {job?.position} </Option>
                            ))}
                          </Select>
                        </Form.Item>
                        {jobDetails.description && (
                            <div>
                              <p><strong>Job Description</strong></p>
                              <p>{jobDetails.description}</p>
                            </div>
                          )}

                        {jobDetails.requirements && (
                          <div>
                            <p><strong>Job Requirements</strong></p>
                            <p>{jobDetails.requirements}</p>
                          </div>
                        )}
                        <Form.Item>
                          <Button htmlType="submit">
                            Submit
                          </Button>
                        </Form.Item>
                      </Form>
                    </div>
                  </Spin>
                </Drawer>
              </div>
            </Col>
            <Col lg={8} md={8} sm={12} xs={24}>
              <div className="img-btn">
                <img src={crowed} alt="crowed" />
                <Button shape="round" className="newsletter-btn" style={{ width: '120px' }} onClick={showDrawerInNewLetter}>Newsletter</Button>
                <Drawer className="newsletter-modal" title="Newsletter" placement="bottom" onClose={onCloseInNewLetter} visible={openNewsLetter}>
                  {newLetterList?.newLetters && newLetterList?.newLetters.map((item: any) => (
                    <div className="newsletter-inner">
                      <Row gutter={16}>
                        <Col lg={18} md={18} sm={12} xs={24}>
                          <label>{item?.headline}</label>
                          <div className="heading-bg" style={{ overflowY: 'scroll' }}>
                            {item?.news}
                          </div>
                        </Col>
                        <Col lg={6} md={6} sm={12} xs={24}>
                          <label>{item?.news_letter_date ? moment(item?.news_letter_date)?.format('YYYY-MM-DD') : null}</label>
                          <div className="image-bg">
                            <img src={item?.profile?.fileUrl} alt="newsletter_image" />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ))};
                </Drawer>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
      <Col lg={12} md={12} sm={24} xs={24}>
        <div className="ourwork-right">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigateToOurService();
            }}
          >
            <img className="img1" src={ourservice} alt="ourservice" />
            <h1>Our Services</h1>
          </a>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigateToOurWork();
            }}
          >
            <img className="img2" src={ourwork} alt="ourwork" />
            <h1>Our Work</h1>
          </a>
        </div>
      </Col>
    </Row>
  );
}

export default inject('authStore')(observer(KUDhome));
